export default __webpack_public_path__ + "087764aa0955b831e541768c41b0f87b.svg";